import { Box, Text, Flex, HStack, Avatar } from 'src/components/ui';
import { ICreative } from 'src/lib/schemas/campaign/newFlowCampaign';
import CommentIcon from 'src/assets/icons/Comment';
import RetweetIcon from 'src/assets/icons/Retweet';
import LikeIcon from 'src/assets/icons/Like';
import StatsIcon from 'src/assets/icons/Stats';
import UploadIcon from 'src/assets/icons/Upload';
import { useContext, useState, useEffect } from 'react';
import UserContext from 'src/contexts/user/UserContext';
import CreativeCard from './CreativeCard';

interface TwitterCreativeProps {
	creative: ICreative;
	withActions?: boolean;
	size?: string;
}
const TwitterCreative = ({
	creative,
	withActions = true,
	size = 'md',
}: TwitterCreativeProps) => {
	const { account } = useContext(UserContext);
	const content = (creative as any).attributes.content;
	const [logo, setLogo] = useState<string | undefined>(account?.logoDark || account?.logoSquare);

	useEffect(() => {
		setLogo(account?.logoDark || account?.logoSquare);
	}, [account]);

	return (
		<CreativeCard
			creative={creative}
			withActions={withActions}
			size={size}
			title="Twitter"
		>
			<Box p={4}>
				<Flex alignItems="center" mb={4} gap={3}>
					<Avatar
						key={logo || 'no-logo'}
						src={logo}
						sx={{
							img: {
								objectFit: 'contain',
							},
						}}
					/>
					<Box>
						<Text fontWeight="bold">{account?.name}</Text>
					</Box>
				</Flex>
				<Text data-testid="twitter-content" mb={2}>
					{content}
				</Text>
				<HStack spacing={10} mt={2}>
					<CommentIcon />
					<RetweetIcon />
					<LikeIcon />
					<StatsIcon />
					<UploadIcon />
				</HStack>
			</Box>
		</CreativeCard>
	);
};

export default TwitterCreative;
